import classnames from 'classnames'
import InfoPopup from '@components/InfoPopup'
import { invoicePriceFormatter } from 'shared/utils'
import featureToggles from 'shared/featureToggles'

import { DELIVERY_COLLECT } from 'purchase-flow/constants'

import styles from './styles.module.scss'

const ProrataSection = ({ prorataInvoice: { tax, items }, total, delivery, startDate }) => (
    <div className={classnames('mt-6', 'justify-content-between', styles.prorataTotal)}>
        <div className="mb-4">
            <h6>
                <T>subscription.purchase.prorata.title</T>
                <span className={styles.startDate}>
                    {' '}
                    (<T>subscription.purchase.prorata.title.startedAt</T> {startDate.displayValue})
                </span>
            </h6>
            <p>
                <T>subscription.purchase.prorata.description</T>
            </p>
        </div>
        {items.map(
            ({ chargeName, productRatePlanChargeId, amountWithoutTax }) =>
                amountWithoutTax > 0 && (
                    <div key={productRatePlanChargeId} className="row mt-2">
                        <div className="col-7 col-sm-10">
                            <span>{chargeName}</span>
                        </div>
                        <div className="col-4 col-sm-2 text-right font-weight-bold">
                            <span>{invoicePriceFormatter(amountWithoutTax)}</span>
                        </div>
                    </div>
                )
        )}
        <hr />
        <div className="row mt-2">
            <div className="col-8 col-sm-10 text-sm-right">
                <span className="mr-3">
                    <T>subscription.purchase.prorata.tax</T>
                </span>
            </div>
            <div className="col-4 col-sm-2 text-right">
                <span>{invoicePriceFormatter(tax)}</span>
            </div>
        </div>
        {delivery && (
            <div className="row mt-2">
                <div className="col-8 col-sm-10 text-sm-right">
                    <span className="mr-3">
                        {featureToggles.hasSubcriptionLite && delivery.prdctCd === DELIVERY_COLLECT ? (
                            delivery.displayValue
                        ) : (
                            <T>subscription.purchase.prorata.shipping</T>
                        )}
                    </span>
                </div>

                <div className="col-4 col-sm-2 text-right">
                    <span>{invoicePriceFormatter(delivery.rate.price)}</span>
                </div>
            </div>
        )}
        <div className={classnames('row', 'mt-2', styles.total)}>
            <div className="col-8 col-sm-10 text-sm-right">
                <span>
                    <T>subscription.purchase.prorata.total</T>
                </span>
                <InfoPopup
                    className="ml-1 align-text-top"
                    content={<T values={{ br: <br /> }}>subscription.purchase.prorata.info.total.text</T>}
                    title={<T>subscription.purchase.prorata.info.title</T>}
                />
            </div>
            <div className="col-4 col-sm-2 text-right">{total}</div>
        </div>
    </div>
)

export default ProrataSection
